import { render, staticRenderFns } from "./OrderCustomFields.vue?vue&type=template&id=44c57d79&"
import script from "./OrderCustomFields.vue?vue&type=script&lang=js&"
export * from "./OrderCustomFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports